import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useScopeCheck } from '../../../reusable-components/scopes';
import { fetchReports } from '../../../redux/slices/reports';
import { useDispatch } from '../../../redux/store';
import ReportsViewBasic from '../../../components/dashboard/reports/basic/ReportsViewBasic';
import ReportsScheduleView from '../../../components/dashboard/reports/schedule/ReportsScheduleView';

export default function Reports() {
  const dispatch = useDispatch();
  const isInScope = useScopeCheck([
    'Super-Admin',
    'OtherReports-Automate',
    'PurchasingReports-Automate',
    'InvoiceReports-Automate',
    'RentalReports-Automate',
    'TransportReports-Automate',
  ]);

  useEffect(() => {
    dispatch(fetchReports());
  }, []);

  return (
    <>
      <Helmet>
        <title>Reports | Platform Solutions</title>
      </Helmet>

      {isInScope ? <ReportsScheduleView /> : <ReportsViewBasic />}
    </>
  );
}
